import {BodyStyle} from "./BodyStyle";
import {Colour} from "./Colour";
import {FuelType} from "./FuelType";
import {Make} from "./Make";
import {Model} from "./Model";

export type Advert = {
    additionalImages: [];
    bodyStyle: BodyStyle;
    colour: Colour;
    comments: string;
    firstSeenDate: string;
    dealer: {
        type: string;
        id: number;
        name: string;
        location: string;
        isApproved: boolean;
    };
    doorsCount: number;
    fuelType: FuelType;
    id: number;
    image: {
        small: string;
        smallMedium: string;
        medium: string;
        large: string;
        original: string;
    };
    lastSeenDate: string;
    make: Make;
    model: Model;
    mileage: number;
    _geoDistance: number;
    options: [];
    price: number;
    lowestMonthlyFinanceFrom: {
        available: boolean;
        human: string;
        pence: number
    };
    slugs: {
        doorsCount: string;
        transmission: string;
        trim: string;
    };
    variant: {
        type: string;
        id: number;
        name: string;
        slug: string;
    };
    year: number;
    _geo: {
        lat: number;
        lng: number;
    };
}